namespace app.support.identidades {
    'use strict';

    angular.module('app.support.identidades', []);
}
